import { useEffect, useState } from "react";
import $ from 'jquery';
import createMixins from "@material-ui/core/styles/createMixins";

const PostContactForm = async (
  values,
  callback,
) => {
  // https://docs.google.com/forms/u/0/d/e/1FAIpQLSeMnCNGnfMjgGgJJ3oMFkXFzBBOaQoeMusx4IxyE1VGKO8Zbg/formResponse
  // name: entry.1498135098
  // email: entry.395986447
  // attendance: entry.1424661284
  // message: entry.877086558
  // if successful

  // post
  var data = {
    'entry.2005620554': values["fullName"],
    'entry.1045781291': values["giftAmount"],
    'entry.1065046570': values["giftNote"]
  };

  var formBody = [];
  for (var property in data) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(data[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");

  function setHeader(xhr) {
    xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
  } 

  $.ajax({
    type: 'POST',
    url: 'https://docs.google.com/forms/u/2/d/e/1FAIpQLSfB3hd_LYeuUMlrWvZs7mCkj3yHwEsdUjq5UePNfVn9JOrMJA/formResponse',
    data: data,
    contentType: 'application/json',
    dataType: 'jsonp',
    complete: callback,
    beforeSend: setHeader
  });
}


const initialFormValues = {
  fullName: "",
  giftAmount: undefined,
  giftNote: ""
};

export const useFormControls = () => {
  const [values, setValues] = useState(initialFormValues);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (window && window.localStorage) {
      const savedGuest = localStorage.getItem("values");
      const saved = localStorage.getItem("gift-values");
      if (saved) {
        setValues(JSON.parse(saved));
      } else if (savedGuest) {
        const guest = JSON.parse(savedGuest);
        setValues({...values, fullName: guest.fullName });
      }
    }
  },[]);

  const validate= (fieldValues = values) => {
    let temp = { ...errors };

    if ("fullName" in fieldValues)
      temp.fullName = fieldValues.fullName ? "" : "This field is required.";

    if ("giftAmount" in fieldValues)
      temp.giftAmount = fieldValues.giftAmount !== undefined && fieldValues.giftAmount > 0 ? "" : "This field is required.";

    setErrors({
      ...temp
    });
  };

  const handleInputValue = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
    validate({ [name]: value });
  };

  const callback = (c) => {
    if (c.status == 404 || (c.status >= 200 && c.status < 300))
      handleSuccess();
    else
      handleError();
  }

  const handleSuccess = (s) => {
    setLoading(false);
    const successValues = {
      ...values,
      formSubmitted: true,
      success: true
    };
    if (window && window.localStorage) {
      localStorage.setItem("gift-values", JSON.stringify(successValues));
    }
    setValues(successValues);
  };

  const handleError = (e) => {
    setLoading(false);
    setValues({
      ...values,
      formSubmitted: true,
      success: false,
      error: e
    });
  };

  const handleReset = () => {
    setValues({
      ...values,
      formSubmitted: false,
      success: false
    });

  }

  const formIsValid = (fieldValues = values) => {
    const isValid =
      fieldValues.fullName &&
      fieldValues.giftAmount > 0
      Object.values(errors).every((x) => x === "");

    

    return isValid;
  };

  const handleFormSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const isValid =
      Object.values(errors).every((x) => x === "") && formIsValid();
    if (isValid) {
      await PostContactForm(values, callback);
    }
  };

  return {
    values,
    errors,
    handleReset,
    handleInputValue,
    handleFormSubmit,
    formIsValid
  };
};
